 
import React, { createContext, useEffect, useRef, useContext, useState } from 'react';
import { errorLog, userLogout } from '@commonservice';
import { useNavigate } from 'react-router-dom';
const IdleTimeoutContext = createContext();

export const IdleTimeoutProvider = ({ children }) => {
    const timeoutRef = useRef(null);
    const [isLoggedOut, setIsLoggedOut] = useState(false);
    const idleTime = 1800000; // 30 minutes in milliseconds
    const navigate = useNavigate();
    const handleLogout = async () => {

        if (!isLoggedOut) {  // Trigger only once
            setIsLoggedOut(true);  // Set logged-out state to true
            alert('You have been logged out due to inactivity.');
            await errorLog({ message: 'idle timeout' }, 'Idle Timeout', 'handleLogout');
            await userLogout(navigate);
        }
        // alert('You have been logged out due to inactivity.');
        // Perform logout logic here (e.g., clear auth tokens, redirect to login)
        // await errorLog({ message: 'idle timeout' }, "Idle Timeout", "handleLogout");

        // localStorage.removeItem('userDetails');
        // localStorage.setItem('isAuthenticated', false);

    // navigate('/session/signin');
    // window.location.href = '/'; // Example redirect
    };

    const resetIdleState = () => {
        setIsLoggedOut(false); // Reset state to allow idle detection
        resetTimer();  // Start the timer again
    };

    const resetTimer = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        if (!isLoggedOut) {
            timeoutRef.current = setTimeout(handleLogout, idleTime);
        }
    };

    useEffect(() => {
        const events = ['mousemove', 'keydown', 'mousedown', 'touchstart'];

        // Add global event listeners
        events.forEach((event) => window.addEventListener(event, resetTimer));

        // Initialize the timer
        resetTimer();

        // Cleanup on unmount
        return () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            events.forEach((event) => window.removeEventListener(event, resetTimer));
        };
    }, [isLoggedOut]);

    return (
        <IdleTimeoutContext.Provider value={{ resetTimer, resetIdleState }}>
            {children}
        </IdleTimeoutContext.Provider>
    );
};

export const useIdleTimeout = () => {
    return useContext(IdleTimeoutContext);
};
